// extracted by mini-css-extract-plugin
export var card = "_lr-5";
export var cardSelected = "_lr-4";
export var image = "_lr-3";
export var modal = "_lr-0";
export var modalContent = "_lr-1";
export var table = "_lr-2";